import DocumentUploadNew from './Documents/DocumentUploadNew'

type DocumentUploadProps = {
  onUpload: (files: File[]) => void
  uploadInformation?: React.ReactNode
  isPdfAllowed?: boolean
}

export default function DocumentUpload({
  onUpload,
  uploadInformation,
  isPdfAllowed = false 
}: DocumentUploadProps) {
  return (
    <DocumentUploadNew
      isPdfAllowed={isPdfAllowed}
      onUpload={onUpload}
      uploadInformation={uploadInformation}
    />
  )
}
